export default {
    message: theme => ({
        mb: '20px',

        [theme.breakpoints.up('md')]: {
            textAlign: 'center',
        }
    }),
};